import React, { FC } from "react";
import { Button, Icon } from "@telia/teddy";

interface BackLinkProps {
    href?: string;
    text: string;
}

const BackLink: FC<BackLinkProps> = ({ href, text }) => (
    <Button variant="text" asChild onClick={href ? undefined : () => window.history.back()}>
        <a href={href || "javascript:void(0)"}>
            <Icon name="arrow-left" aria-hidden="true" focusable="false" />
            {text}
        </a>
    </Button>
);

export default BackLink;
